import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export async function fetchPublicConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function fetchAvailability(date, service, guests = 1, signal) {
  const { data } = await api.get("/availability", {
    params: { date, service, guests },
    signal,
  });
  return data;
}

export async function createBooking(payload, requestId) {
  const { data } = await api.post("/bookings", payload, {
    headers: requestId ? { "X-Booking-Request-Id": requestId } : {},
  });
  return data;
}

export async function verifyAdmin(password) {
  await api.post("/admin/verify", { password });
  return true;
}

export async function fetchBookings(adminPassword) {
  const { data } = await api.get("/bookings", {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function updateBookingStatus(id, status, adminPassword, depositAmount, customMessage) {
  const body = { status };
  if (depositAmount != null) body.deposit_amount = Number(depositAmount);
  if (customMessage != null) body.custom_message = customMessage;
  const { data } = await api.patch(
    `/bookings/${id}/status`,
    body,
    { headers: { "X-Admin-Password": adminPassword } }
  );
  return data;
}

export async function editBooking(id, fields, adminPassword) {
  const { data } = await api.patch(
    `/bookings/${id}`,
    fields,
    { headers: { "X-Admin-Password": adminPassword } }
  );
  return data;
}

export async function fetchAdminSettings(adminPassword) {
  const { data } = await api.get(`/admin/settings`, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function updateAdminSettings(fields, adminPassword) {
  const { data } = await api.put(`/admin/settings`, fields, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function reconcilePayments(adminPassword) {
  const { data } = await api.post(`/admin/payments/reconcile`, {}, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function markBookingPaid(id, adminPassword) {
  const { data } = await api.post(`/admin/bookings/${id}/mark-paid`, {}, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function deleteBooking(id, adminPassword) {
  const { data } = await api.delete(`/bookings/${id}`, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function cleanupExpiredBookings(adminPassword) {
  const { data } = await api.post(`/admin/bookings/cleanup-expired`, {}, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}

export async function checkBookingStripe(id, adminPassword) {
  const { data } = await api.post(`/admin/bookings/${id}/check-stripe`, {}, {
    headers: { "X-Admin-Password": adminPassword },
  });
  return data;
}
